import { render, staticRenderFns } from "./AppFormView.vue?vue&type=template&id=150466c3"
import script from "./AppFormView.vue?vue&type=script&lang=ts"
export * from "./AppFormView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports